<template>
  <div id="about-view">

    <!-- CONTENT -->

    <div id="wideContent">

      <div class="box">
        <div class="boxContent">

          <h1>O nás</h1>

          <p>
            Salon Jája je psí salon, který se v první řadě stará o
            zkrášlování vašich domácích mazlíčků. Stejně tak se ale
            snažíme i o zajištění jejich co největšího pohodlí, ke
            kterému přispívá útulné prostředí našeho salonu. Ten zároveň
            slouží i jako kamenný obchod, kde poskytujeme prodej
            kosmetiky a potřeb pro pejsky a kočičky. Do budoucna
            zvažujeme i rozšíření obchodu do formy e-shopu.
          </p>

          <p>
            S chovem a péčí o pejsky máme letité zkušenosti, jež
            potvrzují i naši mazlíci, jimiž jsou tři pudličky a kocour.
            Od roku 1996 vlastníme chovnou stanici, kde se od roku 2006
            věnujeme chovu malých plemen, především pudl trpasličí a
            toy.
          </p>

          <p>
            Lepší představu o nás a našem salonu Vám nabídne
            fotogalerie níže, protože jak je známo jeden obrázek řekne
            víc než tisíc slov.
          </p>

        </div>
      </div>

      <div class="cleaner">
        <!-- / -->
      </div>


      <div class="box">

        <div class="boxTitle">
          <h2>Fotogalerie</h2>
        </div>

        <div class="boxContent">

          <div class="photo200">

            <a :href="require('../../../static/photos/about/01.jpg')" class="photo fancybox" rel="group" title="Vchod do salonu"><span class="image"><span><img src="../../../static/photos/about/thumb_01.jpg" width="200"/></span></span></a>

            <a :href="require('../../../static/photos/about/02.jpg')" class="photo fancybox" rel="group" title="Střihací stůl"><span class="image"><span><img src="../../../static/photos/about/thumb_02.jpg" width="200"/></span></span></a>

            <div class="cleaner">
              <!-- / -->
            </div>

            <a :href="require('../../../static/photos/about/03.jpg')" class="photo fancybox" rel="group" title="Koupací koutek"><span class="image"><span><img src="../../../static/photos/about/thumb_03.jpg" width="200"/></span></span></a>

            <a :href="require('../../../static/photos/about/04.jpg')" class="photo fancybox" rel="group" title="Kikinka"><span class="image"><span><img src="../../../static/photos/about/thumb_04.jpg" width="200"/></span></span></a>

            <div class="cleaner">
              <!-- / -->
            </div>

            <a :href="require('../../../static/photos/about/05.jpg')" class="photo fancybox" rel="group" title="Sára"><span class="image"><span><img src="../../../static/photos/about/thumb_05.jpg" width="200"/></span></span></a>

            <a :href="require('../../../static/photos/about/06.jpg')" class="photo fancybox" rel="group" title="Maxík"><span class="image"><span><img src="../../../static/photos/about/thumb_06.jpg" width="200"/></span></span></a>

            <div class="cleaner">
              <!-- / -->
            </div>

            <a :href="require('../../../static/photos/about/07.jpg')" class="photo fancybox" rel="group" title="Kačenka"><span class="image"><span><img src="../../../static/photos/about/thumb_07.jpg" width="200"/></span></span></a>

          </div>

          <div class="cleaner">
            <!-- / -->
          </div>

        </div>
      </div>

      <div class="cleaner">
        <!-- / -->
      </div>

    </div>

    <!-- /CONTENT -->

  </div>
</template>

<script>
  import fancybox from './../../assets/js/fancybox'

  export default {
    name: 'about-view',
    head: {
      title: { inner: 'Psí Salon Jája', separator: '-', complement: 'malé představení našeho salonu' },
      meta: [
        { id: 'description', content: 'Jsme psí salon a naším hlavním cílem je zkrášlování vašich psích mazlíčků. S péčí o pejsky máme letité zkušenosti, takže budou v dobrých rukou.' },
        { id: 'keywords', content: 'provozovatel, interiér, fotky' }
      ]
    },
    mounted () {
      fancybox('#about-view .fancybox')
    }
  }
</script>



// WEBPACK FOOTER //
// AboutView.vue?1840e900